import { render, staticRenderFns } from "./Pep-statement-create.vue?vue&type=template&id=50d221ae&scoped=true"
import script from "./Pep-statement-create.vue?vue&type=script&lang=js"
export * from "./Pep-statement-create.vue?vue&type=script&lang=js"
import style0 from "./Pep-statement-create.vue?vue&type=style&index=0&id=50d221ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d221ae",
  null
  
)

export default component.exports